import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { getList } from "core/utils"
import * as CustomPropTypes from "core/proptypes"
import { sanitizeUrl } from "core/utils"

//import "less/opblock"

export default class Operation extends PureComponent {
    static propTypes = {
        path: PropTypes.string.isRequired,
        method: PropTypes.string.isRequired,
        operation: PropTypes.object.isRequired,
        showSummary: PropTypes.bool,

        isShownKey: CustomPropTypes.arrayOrString.isRequired,
        jumpToKey: CustomPropTypes.arrayOrString.isRequired,

        allowTryItOut: PropTypes.bool,

        displayOperationId: PropTypes.bool,
        displayRequestDuration: PropTypes.bool,

        response: PropTypes.object,
        request: PropTypes.object,

        getComponent: PropTypes.func.isRequired,
        authActions: PropTypes.object,
        authSelectors: PropTypes.object,
        specActions: PropTypes.object.isRequired,
        specSelectors: PropTypes.object.isRequired,
        oas3Actions: PropTypes.object.isRequired,
        layoutActions: PropTypes.object.isRequired,
        layoutSelectors: PropTypes.object.isRequired,
        fn: PropTypes.object.isRequired,
        getConfigs: PropTypes.func.isRequired,

        tag: PropTypes.string.isRequired,

        methodType: PropTypes.string,
    }

    static defaultProps = {
        showSummary: true,
        response: null,
        allowTryItOut: true,
        displayOperationId: false,
        displayRequestDuration: false
    }

    constructor(props, context) {
        super(props, context)
        this.state = {
            tryItOutEnabled: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        const defaultContentType = "application/json"
        let { specActions, path, method, operation } = nextProps
        let producesValue = operation.get("produces_value")
        let produces = operation.get("produces")
        let consumes = operation.get("consumes")
        let consumesValue = operation.get("consumes_value")

        if(nextProps.response !== this.props.response) {
            this.setState({ executeInProgress: false })
        }

        if (producesValue === undefined) {
            producesValue = produces && produces.size ? produces.first() : defaultContentType
            specActions.changeProducesValue([path, method], producesValue)
        }

        if (consumesValue === undefined) {
            consumesValue = consumes && consumes.size ? consumes.first() : defaultContentType
            specActions.changeConsumesValue([path, method], consumesValue)
        }
    }

    toggleShown =() => {
        let { layoutActions, isShownKey } = this.props
        layoutActions.show(isShownKey, !this.isShown())
    }

    isShown =() => {
        let { layoutSelectors, isShownKey, getConfigs } = this.props
        let { docExpansion } = getConfigs()

        return layoutSelectors.isShown(isShownKey, docExpansion === "full" ) // Here is where we set the default
    }

    onTryoutClick =() => {
        this.setState({tryItOutEnabled: !this.state.tryItOutEnabled})
    }

    onCancelClick =() => {
        let { specActions, path, method } = this.props
        this.setState({tryItOutEnabled: !this.state.tryItOutEnabled})
        specActions.clearValidateParams([path, method])
    }

    onExecute = () => {
        this.setState({ executeInProgress: true })
    }


    render() {
        let {
            isShownKey,
            jumpToKey,
            path,
            method,
            operation,
            showSummary,
            response,
            request,
            allowTryItOut,
            displayOperationId,
            displayRequestDuration,
            fn,
            getComponent,
            specActions,
            specSelectors,
            authActions,
            authSelectors,
            getConfigs,
            oas3Actions,
            tag,
            methodType
        } = this.props

        let summary = operation.get("summary")
        let description = operation.get("description")
        let deprecated = operation.get("deprecated")
        let externalDocs = operation.get("externalDocs")
        let responses = operation.get("responses")
        let security = operation.get("security") || specSelectors.security()
        let produces = operation.get("produces")
        let schemes = operation.get("schemes")
        let parameters = getList(operation, ["parameters"])
        let operationId = operation.get("__originalOperationId")
        let operationScheme = specSelectors.operationScheme(path, method)

        const Responses = getComponent("responses")
        const Parameters = getComponent( "parameters" )
        const Execute = getComponent( "execute" )
        const Clear = getComponent( "clear" )
        const Markdown = getComponent( "Markdown" )
        const Schemes = getComponent( "schemes" )
        const Collapse = getComponent("Collapse")
        const LiveResponse = getComponent( "liveResponse" )

        const { deepLinking } = getConfigs()

        const isDeepLinkingEnabled = deepLinking && deepLinking !== "false"

        // Merge in Live Response
        if(responses && response && response.size > 0) {
            let notDocumented = !responses.get(String(response.get("status")))
            response = response.set("notDocumented", notDocumented)
        }

        let { tryItOutEnabled } = this.state
        let shown = this.isShown()
        let onChangeKey = [ path, method ] // Used to add values to _this_ operation ( indexed by path and method )

        return (
            <div className={deprecated ? "opblock opblock-deprecated" : shown ? `opblock opblock-${method} is-open` : `opblock opblock-${method}`} id={isShownKey.join("-")} >
                <span className="method-id" id={ methodType ? tag.replace(/\s+/g, '_') + '-' + method.toUpperCase() + '-' + methodType.toUpperCase() : tag.replace(/\s+/g, '_') + '-' + method.toUpperCase() }></span>
                <div className="opblock-summary-description" onClick={this.toggleShown}>
                    <span>{ summary }</span>
                    <span className="opblock-method">{method.toUpperCase()}</span>
                    <i className="material-icons pull-right">{shown ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
                </div>
                <Collapse isOpened={shown}>
                    <div className="thr-opblock-content" >
                        <div className="opblock-description">
							<Markdown source={description} className="tag-desc" />
                        </div>
                        <div className="api-label">API Call:</div>
                        <div className="api-data" style={{
                            marginBottom: this.state.tryItOutEnabled ? '0' : '20px',
                        }}>
                            <span className="opblock-summary-path">{path}</span>
                            <a href="javascript:void(0);" onClick={this.onTryoutClick} className={"btn btn-toggle-test pull-right " + (this.state.tryItOutEnabled ? 'open' : '')}>Try It Out!</a>
                        </div>
                        <Collapse isOpened={this.state.tryItOutEnabled}>
                            <div className="parameter-wrapper">
                                <Parameters
                                    parameters={parameters}
                                    operation={operation}
                                    onChangeKey={onChangeKey}
                                    onTryoutClick = { this.onTryoutClick }
                                    onCancelClick = { this.onCancelClick }
                                    tryItOutEnabled = { tryItOutEnabled }
                                    allowTryItOut={allowTryItOut}
                                    fn={fn}
                                    getComponent={ getComponent }
                                    specActions={ specActions }
                                    specSelectors={ specSelectors }
                                    pathMethod={ [path, method] }
                                    getConfigs={ getConfigs }
                                />
                                <div className="btn-group">
                                    <Execute
                                        getComponent={getComponent}
                                        operation={ operation }
                                        specActions={ specActions }
                                        specSelectors={ specSelectors }
                                        path={ path }
                                        method={ method }
                                        onExecute={ this.onExecute } />
                                    <Clear
                                        onClick={ this.onClearClick }
                                        specActions={ specActions }
                                        path={ path }
                                        method={ method } />
                                </div>
                                {
                                    !response ? null :
                                        <div className="live-response">
                                            <LiveResponse request={ request }
                                                response={ response }
                                                getComponent={ getComponent }
                                                getConfigs={ getConfigs }
                                                specSelectors={ specSelectors }
                                                pathMethod={ [path, method] }
                                                displayRequestDuration={ displayRequestDuration } />
                                        </div>
                                }
                            </div>
                        </Collapse>
                        <div className="api-label">API Responses:</div>
                        <div className="api-data" style={{
                            marginBottom: this.state.tryItOutEnabled ? '0' : '20px',
                        }}>
                            <Responses
                                responses={ responses }
                                request={ request }
                                tryItOutResponse={ response }
                                getComponent={ getComponent }
                                getConfigs={ getConfigs }
                                specSelectors={ specSelectors }
                                oas3Actions={oas3Actions}
                                specActions={ specActions }
                                produces={ produces }
                                producesValue={ operation.get("produces_value") }
                                pathMethod={ [path, method] }
                                displayRequestDuration={ displayRequestDuration }
                                fn={fn} />
                        </div>
                    </div>
                </Collapse>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/plugins/thinkhr/operation.jsx